
































import Vue, { PropType } from 'vue'
import Invitation from '@/types/Invitation.interface'
import { mapGetters } from 'vuex'
import { Plan } from '@/types/Subscription.interface'
import User from '@/types/User.interface'
export default Vue.extend({
    props: {
        //  Decides if this is for the auth or not, defaults to being for auth
        selectedUser: {
            type: Object as PropType<User>,
            default: null
        }
    },
    data() {
        return {
            loading: null,
            freeUsers: null,
            newPlan: null,
            newUsers: null
        }
    },
    mounted() {
        this.init()
    },
    computed: {
        ...mapGetters({
            getLimit: 'getLimit',
            invitations: 'teammatesInvitations',
            user: 'user',
            users: 'teammatesUsers'
        }),
        billedUsers(): number {
            //  Return the number of selected users subtracted from the free users for their plan
            return this.newUsers - this.freeUsers
        },
        currentPlan() {
            // Resolve the current pricing plan out of the subscription
            return this.$store.getters.plan
        },
        invitationCount(): number {
            //  If no invitations, return 0
            if (!this.invitations) return 0

            //  Else count the total that aren't snapdesk/messagedesk/support
            return this.invitations.filter(
                (x: Invitation) =>
                    x.role_id !== 5 &&
                    !x.email.includes('@snapdesk.app') &&
                    !x.email.includes('@messagedesk.com')
            ).length
        },
        userCount(): number {
            return this.$store.getters.userCount
        },
        userLimit(): number {
            //  Grab our total number of users from our stripe plan
            return this.$store.getters.getLimit('user')
        }
    },
    methods: {
        getPlanUsers(plan: Plan): number {
            //  Get the number of free users the subscription allows (including addons)
            const userLimit = this.getLimit('user', true, plan) //seats + plan

            //  Save the old user count
            this.oldUsers = userLimit

            //  Get the free users for the plan (not including addons)
            this.freeUsers = this.getLimit('user', false, plan) // Plan

            //  Return the user limit
            return userLimit
        },
        init(): void {
            //  Set the new free user count for the selected plan
            this.newUsers = this.getPlanUsers(this.newPlan)
        },
        async removeSeat(): Promise<void> {
            //  Start loading phase for buttons
            this.loading = true

            //  Saving userCount for pop up
            const userCount = this.userCount

            //  Saving userLimit for pop up
            const userLimit = this.userLimit

            //  Wrap two API calls in Promise.all to get faster responses
            Promise.all([
                this.$store.dispatch('subscriptionChangeUsers', this.billedUsers - 1),
                this.$store.dispatch('usersDelete', this.selectedUser.id)
            ]).then((response) => {
                this.loading = false

                //  Close dialog
                this.$emit('submit')

                //  Open success dialog
                this.$store.dispatch('dialogOpen', {
                    type: 'MESSAGE',
                    title: 'Teammate Removed',
                    text: `Teammate with email ${
                        this.selectedUser.email
                    } has been removed successfully.\n\nThe monthly fee for this user ($10) has also been removed from your account.\n\nYour Team is now ${
                        userCount - 1
                    }/${userLimit - 1} full. You have ${
                        userLimit - userCount
                    } open seats remaining on your subscription.`,
                    icon: 'bi-check-circle-fill',
                    color: 'primary',
                    closeable: true,
                    width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
                })
            })
        },
        async removeUser(): Promise<void> {
            //  Start loading for buttons
            this.loading = true

            //  Saving userCount for pop up
            const userCount = this.userCount

            //  Saving userLimit for pop up
            const userLimit = this.userLimit

            //  Else, send the delete request to the API
            const response = await this.$store.dispatch(
                'usersDelete',
                this.selectedUser.id
            )

            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Close current dialog
            this.$emit('submit')

            //  Open success dialog
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Teammate Removed',
                text: `Teammate with email ${
                    this.selectedUser.email
                } has been removed successfully.\n\nYour Team is now ${
                    userCount - 1
                }/${userLimit} full. You have ${
                    userLimit - (userCount - 1)
                } open seats remaining on your subscription.`,
                icon: 'bi-check-circle-fill',
                color: 'primary',
                closeable: true,
                width: this.$vuetify.breakpoint.mdAndUp ? '600px' : '400px'
            })
        }
    }
})
